import React from 'react';
import { ToothSurfaceDataType, ToothViewData } from './teethData';
import { ToothSurface } from '../../../../graphql/graphql';

interface OutlineProps {
	stroke: string;
	strokeWidth: number;
	strokeDasharray: string;
}

interface Props {
	toothViewData: ToothViewData;
	surface: ToothSurface;
	color?: string;
	patternId?: string;
	outlineProps?: OutlineProps;
}

const DENTToothSurface: React.FC<Props> = ({
	toothViewData,
	surface,
	color,
	patternId,
	outlineProps = {},
}) => {
	const surfaceData = toothViewData.surfaces[surface];

	if (!surfaceData) {
		return <></>;
	}

	const fillValue = patternId ? `url(#${patternId})` : color || 'transparent';

	if (surfaceData.type === ToothSurfaceDataType.PATH) {
		return <path d={surfaceData.data} fill={fillValue} {...outlineProps} />;
	}

	return (
		<polygon points={surfaceData.data} fill={fillValue} {...outlineProps} />
	);
};

export default DENTToothSurface;
